// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : GOLD CLOSE LOAN TYPES CREATED
// MODIFIED DATE: 23-08-2025

const GoldCloseLoanActionTypes = {
	/** ***************** GET GOLD LOAN MEMBER DETAILS START *********************** */
	GET_GOLD_LOAN_MEMBER_DETAILS_START: 'get_gold_loan_member_details_start',
	GET_GOLD_LOAN_MEMBER_DETAILS_SUCCESS: 'get_gold_loan_member_details_success',
	GET_GOLD_LOAN_MEMBER_DETAILS_FAILURE: 'get_gold_loan_member_details_failure',
	GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_RESET: 'get_gold_loan_member_details_response_reset',
	GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_CHANGED: 'get_gold_loan_member_details_response_changed',
	/** ***************** GET GOLD LOAN MEMBER DETAILS END *********************** */

	/** ***************** UPDATE GOLD CLOSE DETAILS START *********************** */
	UPDATE_GOLD_CLOSE_DETAILS_START: 'update_gold_close_details_start',
	UPDATE_GOLD_CLOSE_DETAILS_SUCCESS: 'update_gold_close_details_success',
	UPDATE_GOLD_CLOSE_DETAILS_FAILURE: 'update_gold_close_details_failure',
	UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_RESET: 'update_gold_close_details_response_reset',
	UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_CHANGED: 'update_gold_close_details_response_changed',
	/** ***************** UPDATE GOLD CLOSE DETAILS END *********************** */
};
export default GoldCloseLoanActionTypes;
